export default {"src":"/_next/static/media/puenting.c065d792.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};